import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';
import { TabularTypeDatasetAdapter, tabularTypeDatasetAdapts } from './tabular-type.dataset.adapter';
import { SapBdcDataset } from 'app/model/dataset/sap-bdc-dataset';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SapBdcDataset),
    asynchronous: true,
    adapts: tabularTypeDatasetAdapts
})
export class SapBdcDatasetAdapter extends TabularTypeDatasetAdapter<SapBdcDataset, Model.DatasetResource> {
    protected async _toResource(dataset: SapBdcDataset): Promise<Model.DatasetResource> {
        return await this._toResourceInternal(dataset, Metamodel.modelFor(SapBdcDataset).name);
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: SapBdcDataset): Promise<SapBdcDataset> {
        return await this._toModelInternal(modelDatasetResource, dataset, SapBdcDataset.MODEL);
    }
}
